// TODO: switch value type to GDSSpacing when theme shape is merged
export const marginX = (value: any) => ({
  marginInlineStart: value,
  marginInlineEnd: value,
});

export const marginY = (value: any) => ({
  marginTop: value,
  marginBottom: value,
});
